import { defineComponent as d, computed as l, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as h, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "a3b43d51-49b3-489b-80d2-235a1eee8560" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#a3b43d51-49b3-489b-80d2-235a1eee8560)" }, u = { key: 0 }, v = /* @__PURE__ */ p('<path fill="#338af3" d="M0 0h512v144.7l-41.4 111.7L512 367.3V512H0V367.3l41.5-107.9L0 144.7z"></path><path fill="#eee" d="M0 144.7h512v222.6H0z"></path><path fill="#ffda44" d="M256 178a78 78 0 1 0 0 156 78 78 0 0 0 0-156zm0 122.5a44.5 44.5 0 1 1 0-89 44.5 44.5 0 0 1 0 89z"></path><path fill="#0052b4" d="M294.6 267.1 256 256l-38.6 11.1-12.8 22.3h102.8z"></path><path fill="#338af3" d="M256 200.3 230.3 245l25.7 11 25.7-11.1z"></path><path fill="#6da544" d="M217.4 267.1h77.2L281.7 245h-51.4z"></path>', 6), g = { fill: "none" }, z = ["r"], y = /* @__PURE__ */ d({
  __name: "ni",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), c = l(() => 256 + e.strokeWidth / 2);
    return (x, b) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      m,
      t("g", k, [
        e.flagName ? (s(), i("title", u, h(e.flagName), 1)) : n("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, _));
  }
});
export {
  y as default
};
//# sourceMappingURL=ni-83168f42.js.map
